import { useMutation, useQuery, useQueryClient } from 'react-query';
import { api } from '#/apis';

const fetchDocuments = async () => {
    const { data } = await api.get('/documents');

    return data;
};

const createDocument = async payload => {

    const { data } = await api.post('/documents', payload);

    return data;
};

const updateDocument = async payload => {
    const { data } = await api.put(`/documents/${payload.id}`, payload);

    return data;
};

const deleteDocument = async documentId => {
    const { data } = await api.delete(`/documents/${documentId}`);

    return data;
};

export const useFetchDocuments = (queryOptions = {}) => useQuery('documents', fetchDocuments, queryOptions);
export const useDeleteDocument = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(documentId => deleteDocument(documentId), {
        onSuccess: () => {
            queryClient.invalidateQueries('documents');
        },
        ...queryOptions
    });
};

export const useCreateDocument = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(payload => createDocument(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('documents');
        },
        ...queryOptions
    });
};

export const useUpdateDocument = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(payload => updateDocument(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('documents');
        },
        ...queryOptions
    });
};
